module.exports = __webpack_public_path__ + "static/media/logo_caregility_lg.ec803727.svg";